import type {Page, Result, UseCase} from 'framework';
import type {CatalogExercise} from '../../domain/catalog-exercise';
import type {WorkoutError} from '../../domain/errors';
import type {
  ExerciseCatalogRepository,
  ListCatalogExercisesInput,
} from '../ports/exercise-catalog.repository';

export class ListCatalogExercises
  implements UseCase<[ListCatalogExercisesInput], Page<CatalogExercise>>
{
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(
    input: ListCatalogExercisesInput,
  ): Promise<Result<Page<CatalogExercise>, WorkoutError>> {
    return this.repository.list(input);
  }
}
